export interface Count {
  type: CountType;
  value: number;
}

export enum CountType {
  UNLIMITED = "UNLIMITED",
  LIMITED = "LIMITED",
}
